import { useState } from "react";
import { StyleProp, View, ViewStyle } from "react-native";
import OpacityView from "src/components/OpacityView";
import { AnimatePresence } from "src/swsh-native";
import useEditCoverGalleryStore from "../../hooks/useEditCoverGalleryStore";
import { EditCoverGalleryTabConfig } from "../../types";
import EditCoverAIGenerationContent from "./components/EditCoverAIGenerationContent";
import EditCoverGatheringPhotosContent from "./components/EditCoverGatheringPhotosContent";
import EditCoverHeader from "./components/EditCoverHeader";
import EditCoverPosterContent from "./components/EditCoverPosterContent";
import EditCoverPreview from "./components/EditCoverPreview";
import EditCoverTabSelector from "./components/EditCoverTabSelector";
import EditCoverUploadContent from "./components/EditCoverUploadContent";

const EditCoverGallery = ({ style }: { style?: StyleProp<ViewStyle> }) => {
	const curConfig = useEditCoverGalleryStore<EditCoverGalleryTabConfig | undefined>((state) =>
		state.selectedTab
			? state.configs.find((config) => config.itemKey === state.selectedTab?.itemKey)
			: undefined,
	);
	const [dimensions, setDimensions] = useState<{
		width: number;
		height: number;
	} | null>(null);

	return (
		<View
			style={style}
			onLayout={(event) => {
				setDimensions({
					width: event.nativeEvent.layout.width,
					height: event.nativeEvent.layout.height,
				});
			}}
		>
			{dimensions != null && (
				<>
					<EditCoverHeader />
					<EditCoverPreview height={dimensions.height} />
					<EditCoverTabSelector />
					<View
						style={{
							flex: 1,
						}}
					>
						<AnimatePresence>
							<OpacityView
								key={curConfig?.itemKey}
								style={{
									position: "absolute",
									width: "100%",
									height: "100%",
								}}
							>
								{curConfig?.variant === "GatheringPhotos" && (
									<EditCoverGatheringPhotosContent
										config={curConfig}
										width={dimensions.width}
									/>
								)}
								{curConfig?.variant === "Posters" && (
									<EditCoverPosterContent
										config={curConfig}
										width={dimensions.width}
									/>
								)}
								{curConfig?.variant === "Upload" && (
									<EditCoverUploadContent config={curConfig} />
								)}
								{curConfig?.variant === "AIGeneration" && (
									<EditCoverAIGenerationContent config={curConfig} />
								)}
							</OpacityView>
						</AnimatePresence>
					</View>
				</>
			)}
		</View>
	);
};
export default EditCoverGallery;
